import { BrowserRouter } from "react-router-dom";
import { KnownRoutes } from "./routes";

function App() {
  return (
    <BrowserRouter>
      <KnownRoutes />
    </BrowserRouter>
  );
}

export default App;
